/**
 * 项目默认配置项
 * primaryColor - 默认主题色, 如果修改颜色不生效，请清理 localStorage
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * colorWeak - 色盲模式
 * layout - 整体布局方式 ['sidemenu', 'topmenu'] 两种布局
 * fixedHeader - 固定 Header : boolean
 * fixSiderbar - 固定左侧菜单栏 ： boolean
 * contentWidth - 内容区布局： 流式 |  固定
 *
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 *
 */

export default {
  storageKey: 'zzcyi_iot_welding_machine_', // 本地缓存前加的key
  navTheme: 'light', // theme for nav menu  dark  light
  primaryColor: '#1890ff', // primary color of ant design
  layout: 'sidemenu', // nav menu position: `sidemenu` or `topmenu`
  contentWidth: 'Fluid', // layout of content: `Fluid` or `Fixed`, only works when layout is topmenu
  fixedHeader: true, // sticky header
  fixSiderbar: true, // sticky siderbar
  colorWeak: false,
  multiTab: true,
  tableSize: 'middle',
  tableBordered: false,
  hideFooter: false,
  title: 'bestarc 管理系统',
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true',
  loginType: 6, // 登录页面类型  1,3,4,5,6
  loginTip: '创新，创造，只为生活更美好',
  loginTip2: 'Innovation,creation,only for better life',
  isLoginLeftLogo: true, // 登录页面是否有右上角logo
  isCodeLogin: false, // 是否支持验证码登录
  isQQLogin: false, // 是否支持QQ登录
  isWxLogin: false, // 是否支持微信登录
  isAliLogin: false, // 是否支持支付宝登录
  isIphoneLogin: false, // 是否支持苹果登录
  isLogoFont: true // 是否显示logo字体
}
